import type { ResolvedMonospacePrimitiveField } from '#layers/data-model/types/schema/resolved-schema';
import { getFieldInputMetaProps, getPrimitiveFieldPresentationDefaults, resolveFieldPresentationBlock } from '#layers/data-model';

const modelControlProps = new Set([
	'modelValue',
	'modelModifiers',
	'onUpdate:modelValue',
	'onUpdate:model-value',
]);

/**
 * Removes model-owned props from persisted field metadata before rendering input blocks.
 */
function sanitizeInputMetaProps(props: Record<string, unknown>): Record<string, unknown> {
	return Object.fromEntries(
		Object.entries(props).filter(([key]) => !modelControlProps.has(key)),
	);
}

/**
 * Resolves the input block configured for a primitive field.
 */
export function getPrimitiveFieldInputBlockOptions(field: ResolvedMonospacePrimitiveField): {
	block: string;
	props?: Record<string, any>;
} {
	const defaults = getPrimitiveFieldPresentationDefaults(field.type).input;
	const inputMetaProps = sanitizeInputMetaProps(getFieldInputMetaProps({
		typeOptions: field.meta?.typeOptions,
		inputOptions: field.meta?.inputOptions,
	}));

	return resolveFieldPresentationBlock(
		defaults,
		field.meta?.inputId,
		{
			...inputMetaProps,
			// TODO: Input blocks should be able to resolve their own default props based on the
			// ResolvedPrimitiveField they are bound to (similar to how display blocks use
			// fieldType.defaultProps). This would let each block own its modelModifiers inference
			// instead of encoding it here.
			...(field.isNullable ? { modelModifiers: { nullable: true } } : {}),
		},
	);
}
